import PropTypes from '../../_util/vue-types';

export var OptionProps = {
  value: PropTypes.string,
  disabled: PropTypes.boolean,
  children: PropTypes.any
};

export default {
  name: 'Option',
  props: OptionProps,
  render: function render() {
    return null;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/vc-mentions/src/Option.js
// module id = 406
// module chunks = 0